module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-700.3abeb876.woff";